import { app } from '../../bootstrap/core';
import { changelogComponent } from './changelog.component';
import { changelogState } from './changelog.state';

app.config(changelogState);
app.component(changelogComponent.name, changelogComponent);



// WEBPACK FOOTER //
// ./src/app/components/changelog/changelog.js